
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.24 12.21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Select_Game copy"}},[_c('path',{attrs:{"fill":"#f8bf13","d":"M4.62 5.97L.4 3.5c-.18-.1-.4.02-.4.23v4.86c0 .47.25.9.66 1.14l4.22 2.45c.18.1.39-.02.39-.23V7.11c0-.47-.25-.9-.65-1.14zM.86 5.74c-.23 0-.41-.26-.41-.59s.18-.59.41-.59.41.27.41.59-.18.59-.41.59zm1.6 2.63c-.23 0-.41-.26-.41-.59s.18-.59.41-.59.41.27.41.59-.18.59-.41.59zm1.76 2.62c-.23 0-.41-.26-.41-.59s.18-.59.41-.59.41.26.41.59-.18.59-.41.59z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M10.84 3.5L6.62 5.97c-.41.24-.65.67-.65 1.14v4.84c0 .21.22.33.39.23l4.22-2.45c.41-.24.66-.67.66-1.14V3.72c0-.2-.22-.33-.39-.23zm-3.8 4.39c-.23 0-.41-.26-.41-.59s.18-.59.41-.59.41.27.41.59-.18.59-.41.59zm3.27 1.23c-.23 0-.41-.26-.41-.59s.18-.59.41-.59.41.27.41.59-.18.59-.41.59z"}}),_c('path',{attrs:{"fill":"#f8bf13","d":"M10.44 2.59L6.29.18a1.3 1.3 0 00-1.32 0L.82 2.59c-.18.1-.18.35 0 .45l4.15 2.41c.41.24.91.24 1.32 0l4.15-2.41c.18-.1.18-.35 0-.45zm-4.72.64c-.4 0-.72-.18-.72-.41s.32-.41.72-.41.72.18.72.41-.32.41-.72.41z"}})])])
          )
        }
      }
    